// extracted by mini-css-extract-plugin
export default {"icons":"SocialIcons_icons__j8nHa"};